/**
 * Crypt Skin - Color schemes for Base components
 *
 * The crypt skin uses player-colored main face gradients and pawn circle gradients.
 * Each scheme defines the gradient stops for the main face fill (paint2–paint5)
 * and the pawn circle fills (paint6–paint9).
 * Fixed elements (gold/bronze frame, dark inner quadrants, decorative bones) are shared.
 */

export interface CryptBaseColorScheme {
  name: string;
  ariaLabel: string;
  /** Main face gradient - primary color (appears at 0%, 47%, 100%) */
  gradientPrimary: string;
  /** Main face gradient - secondary color (appears at 24%, 75%) */
  gradientSecondary: string;
  /** Pawn circle gradient start */
  pawnGradientStart: string;
  /** Pawn circle gradient end */
  pawnGradientEnd: string;
}

export const CRYPT_COLOR_SCHEMES = {
  blue: {
    name: 'blue',
    ariaLabel: 'Blue player home base',
    gradientPrimary: '#0071BC',
    gradientSecondary: '#29ABE2',
    pawnGradientStart: '#0071BC',
    pawnGradientEnd: '#29ABE2'
  },
  red: {
    name: 'red',
    ariaLabel: 'Red player home base',
    gradientPrimary: '#C1272D',
    gradientSecondary: '#F15A24',
    pawnGradientStart: '#C1272D',
    pawnGradientEnd: '#F15A24'
  },
  yellow: {
    name: 'yellow',
    ariaLabel: 'Yellow player home base',
    gradientPrimary: '#F7931E',
    gradientSecondary: '#FCEE21',
    pawnGradientStart: '#F7931E',
    pawnGradientEnd: '#FCEE21'
  },
  green: {
    name: 'green',
    ariaLabel: 'Green player home base',
    gradientPrimary: '#007741',
    gradientSecondary: '#04AE58',
    pawnGradientStart: '#007741',
    pawnGradientEnd: '#04AE58'
  }
} as const satisfies Record<string, CryptBaseColorScheme>;
